import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const getAllExpenseReports = (queryRequest: string) =>
  get(`${config.API_URL}/expense-report?${queryRequest}`);

export const getAllExpenseReportsAdmin = (queryRequest: string) =>
  get(`${config.API_URL}/expense-report/admin?${queryRequest}`);

export const getSpecificExpenseReport = (id: string, token?: string) =>
  get(`${config.API_URL}/expense-report/${id}`, token);

export const createExpenseReport = (payload: object) =>
  post(`${config.API_URL}/expense-report`, payload);

export const updateExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}`, payload);

export const deleteSpecificExpenseReport = (id: string) =>
  Delete(`${config.API_URL}/expense-report/${id}`);

export const getAllExpenseFormReport = (queryRequest: string) =>
  get(`${config.API_URL}/expense-report/form?${queryRequest}`);

export const getAllExpenseReportFormEdit = (id: string) =>
  get(`${config.API_URL}/expense-report/${id}/form-edit`);

const extractDownloadFilename = (
  disposition: string | null,
  fallbackFilename: string,
) => {
  if (!disposition || !disposition.includes("filename=")) {
    return fallbackFilename;
  }

  const match = disposition.match(/filename\*?=['"]?([^;'"]+)/);
  return match?.[1] ? match[1].replace(/["']/g, "") : fallbackFilename;
};

const downloadReportsFile = async (
  endpoint: string,
  queryRequest: string,
  fallbackFilename: string,
) => {
  const access_token = localStorage.getItem("accessToken");
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + access_token,
      "x-tenant-origin":
        window.location.host === "localhost:3000"
          ? config.SOURCE
          : window.location.host,
    },
  };

  const response = await fetch(
    `${config.API_URL}${endpoint}?${queryRequest}`,
    requestOptions,
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const filename = extractDownloadFilename(
    response.headers.get("content-disposition"),
    fallbackFilename,
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return filename;
};

export const deleteExpenseEntryFromReport = (id: string, queryString: string) =>
  Delete(
    `${config.API_URL}/expense-report/${id}/remove/expense?${queryString}`
  );

export const attachExpenseEntryInReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/attach/expense`, payload);

//File Upload documents
export const attachDocumentsToExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/upload/documents`, payload);

export const deleteDocumentsFromExpenseReport = (
  id: string,
  queryString: string
) => Delete(`${config.API_URL}/expense-report/${id}/document?${queryString}`);

export const submitExpenseReport = (payload: object) =>
  post(`${config.API_URL}/expense-report/submit`, payload);

// export const approveExpenseReport = (id: string) =>
//   get(`${config.API_URL}/expense-report/${id}/approve`);

export const approveExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/approve`, payload);

// export const rejectExpenseReport = (id: string) =>
//   get(`${config.API_URL}/expense-report/${id}/reject`);

export const recallExpenseReport = (id: string) =>
  get(`${config.API_URL}/expense-report/${id}/recall`);

export const rejectExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/reject`, payload);

export const sentbackExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/sent-back`, payload);

export const undoSentbackExpenseReport = (id: string, payload: object = {}) =>
  patch(`${config.API_URL}/expense-report/${id}/sent-back/undo`, payload);

export const expenseReportValidateApprovalFlowType = (id: string) =>
  get(`${config.API_URL}/expense-report/${id}/validate/approver-flow-type`);

//trip submission Admin
export const adminApproveExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/admin/approve`, payload);

export const adminRejectExpenseReport = (id: string, payload: object) =>
  patch(`${config.API_URL}/expense-report/${id}/admin/reject`, payload);

//comments

export const expenseReportComments = (id: string, queryRequest: string) =>
  get(`${config.API_URL}/expense-report/${id}/comment?${queryRequest}`);

//reimbursement
export const expenseRecordReimbursement = (payload: object) =>
  post(`${config.API_URL}/expense-report/admin/record-reimbursement`, payload);

export const approvalReportsDownload = async (queryRequest: string) =>
  downloadReportsFile(
    "/reports/expense-report/download",
    queryRequest,
    "expense-report.xlsx",
  );

export const approvalReportsDownloadExpenses = async (queryRequest: string) =>
  downloadReportsFile(
    "/reports/expense-report-expense/download",
    queryRequest,
    "expense-report-expense.xlsx",
  );

export const adminReportsDownloadReimbursement = async (reimbursement_id: string) => {
  const access_token = localStorage.getItem("accessToken");
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + access_token,
      "x-tenant-origin":
        window.location.host === "localhost:3000"
          ? config.SOURCE
          : window.location.host,
    },
  };

  const response = await fetch(
    `${config.API_URL}/expense-report/download-pdf/${reimbursement_id}`,
    requestOptions
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }


  const disposition = response.headers.get("content-disposition");
  let filename = "download.pdf";
  if (disposition && disposition.includes("filename=")) {
    const match = disposition.match(/filename\*?=['"]?([^;'"]+)/);
    if (match && match[1]) {
      filename = match[1].replace(/["']/g, "");
    }
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return filename; 
};

export const adminReportsZipAttachmentsDownload = async (report_id: string) => {
  const access_token = localStorage.getItem("accessToken");
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + access_token,
      "x-tenant-origin":
        window.location.host === "localhost:3000"
          ? config.SOURCE
          : window.location.host,
    },
  };

  const response = await fetch(
    `${config.API_URL}/expense-report/download-zip/${report_id}`,
    requestOptions
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }


  const disposition = response.headers.get("content-disposition");
  let filename = "download.pdf";
  if (disposition && disposition.includes("filename=")) {
    const match = disposition.match(/filename\*?=['"]?([^;'"]+)/);
    if (match && match[1]) {
      filename = match[1].replace(/["']/g, "");
    }
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return filename; 
};

 
